import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loginUser, apiError } from "../../store/actions";
import { useNavigate } from 'react-router-dom';

const Auth0Handler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const handleAuth = async () => {
      console.log('Auth0Handler: Checking authentication');
      if (isAuthenticated && user) {
        try {
          console.log('Auth0Handler: User authenticated, getting token');
          const token = await getAccessTokenSilently();
          
          const userData = {
            token,
            email: user.email,
            name: user.name,
            picture: user.picture,
            sub: user.sub
          };
          
          console.log('Auth0Handler: Dispatching login action');
          dispatch(loginUser(userData, navigate));
        } catch (error) {
          console.error('Auth0Handler: Token error:', error);
          dispatch(apiError(error));
          navigate('/login');
        }
      }
    };

    handleAuth();
  }, [isAuthenticated, user, getAccessTokenSilently, dispatch, navigate]);

  // Optional loading state
  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  <div style={{ textAlign: 'center' }}>
    <div className="spinner" style={{ marginBottom: '1rem', width: '3rem', height: '3rem', border: '0.4rem solid #dee2e6', borderTop: '0.4rem solid #007bff', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
    <p style={{ color: '#6c757d', fontSize: '1.2rem' }}>Authenticating...</p>
  </div>
  <style>
    {`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}
  </style>
</div>;
};

export default Auth0Handler;